/*
 * @Author: hongqi
 * @LastEditors: hongqi
 * @Date: 2020-12-23 14:18:56
 * @LastEditTime: 2021-01-04 15:24:14
 */

const HOST = 'https://wap.ys141319.com/'

const HOST_H5 = HOST + 'h5/'
// const HOST_API = HOST + 'api/'
const HOST_API = '/api/'
const HOST_API_V1 = HOST_API + 'v1.'
const HOST_API_V2 = HOST_API + 'v2.'

const API = {


    /**
     * @公共
     */
    // 主域名
    HOST,
    // H5域名
    HOST_H5,
    // 七牛云
    qiniuToken: '/api/qiniu/up_token',
    // 阿里云上传
    uploadToAliOss: HOST_API + 'alioss/uploadAfter',
    // 联系我们
    customer_service: HOST_API_V2 + 'user/customer_service',
    // 关于我们
    about: HOST_API_V2 + 'common/about',
    // 微信配置信息
    wx_setup_info: HOST_API_V2 + 'util/wx_setup_info',
    // 物流信息
    logistics_detail: HOST_API_V2 + 'util/logistics',

    /**
     * @账户
     */
    // 登录
    login: HOST_API_V2 + 'login/login',
    // 微信授权登录_H5
    oauth_callback: HOST_API_V2 + 'login/oauth_callback',
    // 绑定关系
    login_bind_agent: HOST_API_V2 + 'login/bindAgent',
    // 注册
    register: HOST_API_V2 + 'login/register',
    // 发送短信
    smsCode: HOST_API_V2 + 'util/send_sms',
    // 手机验证码登录
    code_login: HOST_API_V2 + 'login/code_login',
    // 绑定手机号
    wx_bind_mobile: HOST_API_V2 + 'login/wx_bind_mobile',
    // 修改手机号
    change_mobile: HOST_API_V2 + 'User/change_mobile',
    // 修改密码
    reset_password: HOST_API_V2 + 'user/reset_password',
    // 绑定手机号
    bindMobile: HOST_API_V1 + 'login/binding',
    // 微信授权登录
    wx_login: HOST_API_V2 + 'login/wx_login',
    // 增加绑定
    binding_wechat: HOST_API_V2 + 'login/binding_wechat',
    // 解除微信绑定
    unbundle_wechat: HOST_API_V2 + 'login/unbundle_wechat',
    // 微信绑定手机号
    bind: HOST_API_V2 + 'login/wx_bind_mobile',
    // 重置密码
    reset_forget_password: HOST_API_V2 + 'login/reset_forget_password',
    // 用户协议
    user_agreement: HOST_API_V2 + '/user_agreement',
    // 用户信息
    user_info: HOST_API_V2 + 'user/info',
    // 地址列表
    user_address_address_list: HOST_API_V2 + 'user_address/address_list',
    // 地址详情
    user_address_detail: HOST_API_V2 + 'user_address/detail',
    // 添加/编辑地址
    user_address_add: HOST_API_V2 + 'user_address/add',
    // 删除地址
    user_address_del: HOST_API_V2 + 'user_address/del',
    // 设置默认地址
    user_address_set_default: HOST_API_V2 + 'user_address/set_default',

    /**
     * @课程
     */
    // 课程报名列表
    course_enroll_list: HOST_API_V2 + 'subject/enroll_subject_list',
    // 课程报名详情
    enroll_subject_detail: HOST_API_V2 + 'subject/enroll_subject_detail',
    // 课程介绍列表
    course_introduce_list: HOST_API_V2 + 'subject/subject',
    // 课程介绍详情
    subject_detail: HOST_API_V2 + 'subject/subject_detail',
    // 解锁课程
    do_ticket: HOST_API_V2 + 'subject/do_ticket',
    // 报名列表
    enroll_index: HOST_API_V2 + 'class_enroll/enroll_index',
    // 报名
    do_enroll: HOST_API_V2 + 'class_enroll/do_enroll',
    // 义工记录
    volunteer_my_volunteer_log: HOST_API_V2 + 'volunteer/my_volunteer_log',
    // 我的课程
    my_enroll_subject_list: HOST_API_V2 + 'student_zone/my_enroll_subject_list',
    // 我的课程
    my_enroll_subject_detail: HOST_API_V2 + 'student_zone/my_enroll_subject_detail',
    // 我的课程附件
    my_enroll_subject_affix: HOST_API_V2 + 'subject/affix',

    /**
     * @home
     */
    // 首页公告
    home_notice_alert: HOST_API_V2 + 'student_zone/home_notice_alert',
    // 首页公告 - 阅读
    home_notice_read: HOST_API_V2 + 'student_zone/read_detail',
    // 首页
    home_page_index: HOST_API_V2 + 'Home_page/index',
    // 传承师、讲师 - 列表
    master_user_list: HOST_API_V2 + 'home_page/master_user_list',
    // 传承师、讲师 - 详情
    master_user_detail: HOST_API_V2 + 'home_page/master_user_detail',
    // 精品文章、每日易报点赞
    home_page_like: HOST_API_V2 + 'home_page/like',
    // 分享统计
    share_content: HOST_API_V2 + 'home_page/share_content',
    // 分享获得积分
    share_to_get_point: HOST_API_V2 + 'point/point_share',

    /**
     * @运势
     */
    // 历史运势
    destiny_list: HOST_API_V2 + 'home_page/destiny_list',
    // 运势详情
    destiny_detail: HOST_API_V2 + 'Home_page/destiny',
    // 运势评论列表
    destiny_comment_list: HOST_API_V2 + 'home_page/destiny_comment_list',
    // 发布运势评论
    destiny_comment: HOST_API_V2 + 'home_page/destiny_comment',
    // 运势点赞
    destiny_like: HOST_API_V2 + 'home_page/like',

    /**
     * @文章
     */
    // 文章列表
    article_list: HOST_API_V2 + 'recommend/article_list',
    // 文章详情
    article_detail: HOST_API_V2 + 'recommend/article_detail',
    // 文章评论列表
    article_comment_list: HOST_API_V2 + 'recommend/article_comment_list',
    // 发布文章评论
    article_comment: HOST_API_V2 + 'recommend/article_comment',
    // 文章分类
    category_list: HOST_API_V2 + 'recommend/category_list',
    // 发布文章
    save_my_article: HOST_API_V2 + 'recommend/save_my_article',

    /**
     * @沙龙
     */
    // 沙龙列表
    salon_index: HOST_API_V2 + 'salon/index',
    // 我的沙龙
    salon_my_salon: HOST_API_V2 + 'salon/my_salon',
    // 沙龙详情
    salon_detail: HOST_API_V2 + 'salon/detail',
    // 发布沙龙
    save_salon: HOST_API_V2 + 'salon/save_salon',
    // 报名沙龙
    salon_enroll: HOST_API_V2 + 'salon/salon_enroll',
    // 暂存沙龙正式发布
    release_salon: HOST_API_V2 + 'salon/release_salon',
    // 结束沙龙
    stop_salon: HOST_API_V2 + 'salon/stop_salon',

    /**
     * @传承师
     */
    // 传承师列表
    master_list: HOST_API_V2 + 'home_page/master_list',

    /**
     * @商城
     */
    // 商城首页
    shop_home: HOST_API_V2 + 'shop/home',
    // 商品列表
    shop_goods_list: HOST_API_V2 + 'shop/goods_list',
    // 商品详情
    shop_goods_detail: HOST_API_V2 + 'shop/goods_detail',
    // 规格页
    shop_sku_detail: HOST_API_V2 + 'shop/sku_detail',
    // 加入购物车
    shop_cart_add: HOST_API_V2 + 'shop_cart/add',
    // 购物车删除
    shop_cart_del: HOST_API_V2 + 'shop_cart/del',
    // 购物车列表
    shop_cart_cart_list: HOST_API_V2 + 'shop_cart/cart_list',
    // 下单前检查订单
    shop_preview_check_order: HOST_API_V2 + 'shop/preview_check_order',
    // 更新购物车
    shop_update: HOST_API_V2 + 'shop_cart/update',
    // 获取运费
    shop_freight: HOST_API_V2 + 'shop/freight',
    // 立即支付
    shop_create_order: HOST_API_V2 + 'shop/create_order',
    // 订单支付
    shop_pay_order: HOST_API_V2 + 'shop/pay_order',
    // 订单列表
    shop_order_list: HOST_API_V2 + 'shop/order_list',
    // 订单删除
    shop_order_detail: HOST_API_V2 + 'shop/order_detail',
    // 取消订单
    shop_cancel_order: HOST_API_V2 + 'shop/cancel_order',
    // 订单收货
    shop_receive_order: HOST_API_V2 + 'shop/receive_order',
    // 申请退款
    shop_apply_order_refund: HOST_API_V2 + 'shop/apply_order_refund',
    // 填写退款信息
    shop_logistics_info: HOST_API_V2 + 'shop/logistics_info',
    // 撤销退款
    shop_revoke_refund: HOST_API_V2 + 'shop/revoke_refund',
    // 退款记录
    shop_refund_record: HOST_API_V2 + 'shop/refund_record',
    // 退款记录
    shop_refund_reason: HOST_API_V2 + 'shop/refund_reason',

    /**
     * @积分商城
     */
    // 积分商城 - 首页
    point_shop_home: HOST_API_V2 + 'point_shop/home',
    // 积分商城 - 商品列表
    point_shop_goods_list: HOST_API_V2 + 'point_shop/goods_list',
    // 积分商城 - 商品列表
    point_shop_goods_detail: HOST_API_V2 + 'point_shop/goods_detail',
    // 积分商城 - 商品规格属性
    point_shop_sku_detail: HOST_API_V2 + 'point_shop/sku_detail',
    // 积分商城 - 创建订单
    point_shop_create_order: HOST_API_V2 + 'point_shop/create_order',
    // 积分商城 - 支付订单
    point_shop_pay_order: HOST_API_V2 + 'point_shop/pay_order',
    // 积分商城 - 订单列表
    point_shop_order_list: HOST_API_V2 + 'point_shop/order_list',
    // 积分商城 - 订单详情
    point_shop_order_detail: HOST_API_V2 + 'point_shop/order_detail',
    // 积分商城 - 确认收货
    point_shop_receive_order: HOST_API_V2 + 'point_shop/receive_order',

    /**
     * @会员中心
     */
    // 个人资料
    user_save: HOST_API_V2 + 'user/save',
    // 获取传承师/代理商申请信息
    master_agent_info: HOST_API_V2 + 'user/master_agent_info',
    // 实名认证
    check_real_name: HOST_API_V2 + 'student_zone/check_real_name',
    // 每日签到
    daily_sign_in: HOST_API_V2 + 'student_zone/sign_in',
    // 每日签到 - 签到记录
    daily_sign_log: HOST_API_V2 + 'student_zone/sign_log',
    // 我的消息
    message_list: HOST_API_V2 + 'student_zone/news',
    // 上课凭证
    my_class_voucher: HOST_API_V2 + 'student_zone/my_enroll_voucher',
    // 缴费记录
    my_pay_record: HOST_API_V2 + 'student_zone/my_pay_record',
    // 常见问题
    faq_list: HOST_API_V2 + 'common/faq',
    // 我的积分
    my_points_info: HOST_API_V2 + 'student_zone/my_points_info',
    // 我的收入
    revenue_list: HOST_API_V2 + 'agent/revenue_list',
    // 我的商城钱包列表
    wallet_shop_list: HOST_API_V2 + 'agent/wallet_shop_list',
    // 提现首页
    withdrawal_config: HOST_API_V2 + 'agent/withdrawal_config',
    // 提现记录
    withdrawal_record: HOST_API_V2 + 'agent/withdrawal_record',
    // 提现记录
    apply_cash_out: HOST_API_V2 + 'agent/apply_cash_out',

    /**
     * @传承师
     */
    // 传承师状态
    master_status: HOST_API_V2 + 'Master/status',
    // 传承师申请
    master_apply: HOST_API_V2 + 'Master/apply',

    /**
     * @代理商
     */
    // 分公司列表
    agent_company_all: HOST_API_V2 + 'Agent/companyAll',
    // 代理商状态
    agent_status: HOST_API_V2 + 'Agent/status',
    // 代理商申请
    agent_apply: HOST_API_V2 + 'Agent/apply',
    // 课程记录
    agent_subject_record: HOST_API_V2 + 'agent/subject_record',
    // 课程记录--报名列表
    agent_enroll_index: HOST_API_V2 + 'agent/enroll_index',
    // 我的团队tab搜索部分
    agent_my_team_search: HOST_API_V2 + 'agent/my_team_search',
    // 我的团队
    agent_my_team: HOST_API_V2 + 'agent/my_team',
    // 我的团队 - 学员详情
    agent_student_detail: HOST_API_V2 + 'agent/student_detail',
    // 我的团队 - 学员记录
    agent_student_record: HOST_API_V2 + 'agent/student_record',
    // 沙龙报名列表
    salon_enroll_list: HOST_API_V2 + 'salon/enroll_list',
    // 沙龙 - 签到
    salon_do_sign: HOST_API_V2 + 'salon/do_sign',
    // 沙龙 - 解锁众修班
    salon_buy_subject: HOST_API_V2 + 'salon/buy_subject',
    // 我的门票
    user_ticket_list: HOST_API_V2 + 'user/ticket_list',
    // 我的门票 - 撤回门票
    user_ticket_revoke: HOST_API_V2 + 'user/ticket_revoke',
    // 我的门票 - 审核门票
    salon_ticket_check: HOST_API_V2 + 'salon/ticket_check',
    // 门票状态
    ticket_agent_ticket: HOST_API_V2 + 'ticket/agentTicket',
    // 发放门票
    ticket_grant_ticket: HOST_API_V2 + 'ticket/grantTicket',
    // 发放详情
    ticket_grant_detail: HOST_API_V2 + 'ticket/grantDetail',
    // 领取门票
    ticket_use_ticket: HOST_API_V2 + 'ticket/useTicket',

    // https://wap.ys141319.com/h5/goods/yunfei这是配送费点击进入的页面
    // https://wap.ys141319.com/h5/goods/gouwu这是购物须知
}
export default API